import React from "react";
import "./ViewToggle.css";

export type ViewToggleProps = {
  view: "list" | "cards";
  setView: (view: "list" | "cards") => void;
};

export const ViewToggle = ({ view, setView }: ViewToggleProps) => {
  return (
    <div className="view-container">
      <div className="view-filler" />
      <div onClick={() => setView("list")} className="view-icon-container">
        <img
          className="view-icon"
          alt="list view"
          src={
            view !== "list"
              ? "/icons/list-view.svg"
              : "/icons/list-view-active.svg"
          }
        />
      </div>
      <div onClick={() => setView("cards")} className="view-icon-container">
        <img
          className="view-icon"
          alt="cards view"
          src={
            view !== "cards"
              ? "/icons/cards-view.svg"
              : "/icons/cards-view-active.svg"
          }
        />
      </div>
    </div>
  );
};
